<template>
  <div class="main">
    <!--顶部-->
    <div class="memtop">
      <div class="memtx">
        <div class="memtx_left">
          <img src="../../assets/images/tx.png" />
        </div>
        <div class="memnm">
          <div class="mems_top">
            <div class="mems_name ellipsis fs36">
              {{ accountInfo.login_name }}
            </div>
          </div>
          <div class="mems_msg ellipsis fs26">
            {{ accountInfo.name }}
          </div>
        </div>
      </div>
      <div class="mems">
        <div class="mem" @click="domsg">
          <p class="p1 fs28">0.00￥</p>
          <p class="p2 fs28">{{ $t("member.user_top_balance") }}</p>
        </div>
        <div class="mem" @click="domsg">
          <p class="p1 fs28">0</p>
          <p class="p2 fs28">{{ $t("member.user_top_bill") }}</p>
        </div>
        <div class="mem" @click="handleMessage">
          <p class="p1 fs28">{{ count }}</p>
          <p class="p2 fs28">{{ $t("member.user_top_notice") }}</p>
        </div>
      </div>
    </div>
    <!--顶部 end-->
    <!--功能区-->
    <div class="memfuns">
      <div
        class="memfun"
        v-for="item in list"
        :key="item.name"
        @click="handleProxyEvent(item.eventName)"
        v-if="item.display !== false"
      >
        <div v-if="item.eventName !== 'aboutUs'">
          <img :src="item.icon" />
          <div class="txt fs28">{{ item.name }}</div>
        </div>
        <div v-else>
          <img :src="item.icon" />
          <a
            class="txt fs28"
            href="https://t.asczwa.com/taobao?backurl=https://shop598162228.taobao.com/?spm=pc_detail.29232929/evo365560b447259.shop_block.dentershop.28ba7dd6UTLzSg"
            rel="external nofollow"
            >{{ item.name }}</a
          >
        </div>
      </div>
    </div>
    <!--功能区 end-->
    <div class="footer">
      <customFooter :ison="3"></customFooter>
    </div>
  </div>
</template>

<script>
// import YLUtils from 'yuluoo-hospital-utils';

export default {
  data() {
    return {
      list: [
        {
          name: this.$t("member.user_me1"),
          icon: require("../../assets/images/me1.png"),
          eventName: "domsg"
        },
        {
          name: this.$t("member.user_me7"),
          icon: require("../../assets/images/add.png"),
          eventName: "addEquip"
        },
        {
          name: this.$t("member.user_me2"),
          icon: require("../../assets/images/me2.png"),
          eventName: "handleChangePwd"
        },
        {
          name: this.$t("member.user_me3"),
          icon: require("../../assets/images/cjwt.png"),
          eventName: "domsg"
        },
        {
          name: this.$t("member.user_me4"),
          icon: require("../../assets/images/gywm.png"),
          // eventName: 'domsg',
          eventName: "aboutUs"
        },
        {
          type: "diy",
          name: "开启微信推送",
          icon: require("../../assets/images/kqwxts.png"),
          eventName: "openWxPush"
        },
        {
          name: this.$t("member.user_me5"),
          icon: require("../../assets/images/lxwm.png"),
          eventName: "domsg"
        },
        {
          name: this.$t("member.user_me9"),
          icon: require("@/assets/images/sbts.png"),
          eventName: "debug"
        },
        {
          name: this.$t("member.user_me11"),
          icon: require("@/assets/images/bchsb.png"),
          eventName: "handleDiseasesPests"
        },
        // {
        //   name: '轮灌组',
        //   icon: require('../../assets/images/sbts.png'),
        //   eventName: 'lunGuan',
        // },
        {
          name: this.$t("member.user_me6"),
          icon: require("../../assets/images/me6.png"),
          eventName: "outLogin"
        }
        // {
        //   name: '测试新的实况页面',
        //   icon: require('../../assets/images/me6.png'),
        //   eventName: 'test',
        // },
      ],

      accountInfo: {},
      count: 0
    };
  },

  mounted() {
    this.getAccountInfo();
    this.getMessageUnread();
  },

  methods: {
    getAccountInfo() {
      this.$api.getUserAccountInfo().then(res => {
        if (res.errcode === 0) {
          this.accountInfo = res.data;
        }
      });
    },

    getMessageUnread() {
      this.$api.getMessageUnread().then(res => {
        if (res.errcode === 0) {
          this.count = res.count;
        }
      });
    },

    handleProxyEvent(eventName) {
      this[eventName]();
    },

    domsg() {
      this.$toast(this.$t("member.dele"));
    },

    // 我的消息
    handleMessage() {
      this.$router.push("/member/message");
    },

    openWxPush(bl) {
      this.$router.push({
        path: "/openWxPush"
      });
    },
    debug() {},

    //退出登录
    outLogin() {
      var _this = this;
      this.$dialog
        .confirm({
          title: this.$t("member.login_out_title"),
          message: this.$t("member.login_out_msg"),
          confirmButtonText: this.$t("member.login_out_ok"),
          cancelButtonText: this.$t("member.login_out_cancel")
          // title: this.$t('member.login_out_title'),
          // message: this.$t('member.login_out_msg'),
          // confirmButtonText: this.$t('member.login_out_ok'),
          // cancelButtonText: this.$t('member.login_out_cancel')
        })
        .then(() => {
          this.$api.outLogin({}).then(res => {
            console.log(res);
            if (res.errcode == 0) {
              _this.$toast(this.$t("member.login_out_success"));
              localStorage.removeItem("token");
              setTimeout(function() {
                _this.$router.push({ path: "/live" });
              }, 2000);
            } else {
              _this.$toast(this.$t("member.login_out_fail"));
            }
          });
        })
        .catch(err => {
          // 其他异常
          _this.$toast.clear();
        });
    },

    // 添加设备
    addEquip() {
      window.location.href = window.location.origin + "/addEquip";
    },

    // 轮灌设计
    lunGuan() {
      this.$router.push("/lunGuan");
    },

    // 病虫害识别
    handleDiseasesPests() {
      this.$router.push("/diseasesPests");
    },

    debug() {
      this.$router.push("/debug");
    },

    aboutUs() {},

    // test() {
    //   this.$router.push('/newLive')
    // },
    handleChangePwd() {
      this.$router.push("/changepwd");
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  overflow-y: scroll;
}

/*顶部*/
.memtop {
  position: relative;
  height: 4.5rem;
  background: url(./../../assets/images/mebg.png) center no-repeat;
  background-size: 100% 100%;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1000;
}

.memtx {
  overflow: hidden;
  padding: 0.5rem 0.2rem 0.3rem;
}
.memtx .memtx_left {
  float: left;
}
.memtx .memtx_left,
.memtx .memtx_left img {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  overflow: hidden;
}
.memnm {
  padding-left: 1.7rem;
  color: #fff;
}
.memnm .mems_top {
  overflow: hidden;
  line-height: 0.36rem;
  padding-top: 0.3rem;
}
.memnm .mems_top .mems_name {
  float: left;
}
.memnm .mems_top .mems_time {
  float: right;
}
.memnm .mems_msg {
  width: 100%;
  height: 0.45rem;
  line-height: 0.45rem;
  /* text-align: center; */
  /* background: url(../../assets/images/zn.png) no-repeat; */
  background-size: 1.43rem 0.45rem;
  margin-top: 0.2rem;
}
.mems {
  text-align: center;
  overflow: hidden;
  padding-top: 0.3rem;
}
.mems .mem {
  width: 33.33%;
  float: left;
  color: #fff;
}
.mems .mem .p2 {
  padding-top: 0.05rem;
}
/*顶部 end*/

/*功能区*/
.memfuns {
  position: relative;
  left: 0.2rem;
  top: -0.7rem;
  width: 7.1rem;
  box-shadow: 0 0.06rem 0.1rem #eee;
  border-radius: 0.1rem;
  // margin-top: -0.64rem;
  margin-bottom: 2.2rem;
  z-index: 2;
  background: #fff;

  &::after {
    content: " ";
    clear: both;
  }
}

.memfun {
  overflow: hidden;
  border-bottom: 1px solid #f8f8f8;
  padding: 0.3rem 0;
  position: relative;
}
.memfun a {
  display: block;
  overflow: hidden;
}
.memfun::after {
  position: absolute;
  content: "";
  width: 0.16rem;
  height: 0.16rem;
  border-top: 2px solid #bbbbbb;
  border-right: 2px solid #bbbbbb;
  transform: rotate(45deg);
  top: 50%;
  margin-top: -0.08rem;
  right: 0.4rem;
}
.memfun img {
  width: 0.38rem;
  height: 0.38rem;
  float: left;
  margin: 0 0.2rem 0 0.37rem;
}
.memfun .txt {
  display: block;
  float: left;
  line-height: 0.4rem;
  color: #333;
}
/*功能区 end*/
</style>
